import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  const { lang: langParam } = useParams();
  const lang = langParam === "en" ? "en" : "ar";
  return (
    <main id="main" className="min-h-[70vh] flex items-center pt-[120px]">
      <div className="zv-container text-center">
        <div className="zv-serif text-[120px] leading-none text-[#c8622a]">404</div>
        <h1 className="zv-serif text-4xl mt-4">{t("not_found.title")}</h1>
        <p className="mt-4 text-[16px] text-[#2a303b]">{t("not_found.lead")}</p>
        <Link to={`/${lang}`} className="zv-btn zv-btn-primary mt-8">
          {t("not_found.back")}
        </Link>
      </div>
    </main>
  );
}
